<template>
  <section>
    <div class="lm-header">
      <h2
        class="title is-5"
        v-text="$t('DashboardEDF.title').toUpperCase()"
      />
      <h3
        class="subtitle is-5"
        v-text="$t('Common.filters')"
      />
    </div>
    <edf-filters/>
    <edf
      type="sortEdf"
    />
  </section>
</template>

<script>
import EdfFilters from '@/components/filters/EdfFilters'
import Edf from '@/components/dashboard/Edf'

export default {
  name: 'DashboardEDF',
  beforeCreate () {
    this.$store.dispatch('orders/flush')
    this.$store.dispatch('filters/flush')
  },
  components: {
    EdfFilters,
    Edf
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/DashboardEDF.vue